(function () {
  var TK = window.TKCatalog || { categories: [], models: [] };

  if (!Array.isArray(window.DEVICES) || window.DEVICES.length === 0) {
    window.DEVICES = TK.models || [];
  }

  window.DEVICE_GATE = { required: [] };
  window.DEVICE_TYPES = [
    { id: "phone",   label: "Smartphones", icon: "phone"  },
    { id: "tablet",  label: "Tablets",     icon: "tablet" },
    { id: "laptop",  label: "Mac",         icon: "laptop" },
    { id: "console", label: "Game Systems", icon: "console" }
  ];

  window.TK_TYPE_CATEGORY = {
    phone:   "smartphones",
    tablet:  "tablets",
    laptop:  "mac",
    console: "game-systems"
  };
})();
